import "./VerificationHub.module.css";
import Header from "@/reusable_sections/Header";
import Verification from "./sections/Verification";
import BatchResults from "./sections/BatchResults";
import Footer from "@/reusable_sections/Footer";
export default function VerificationHubPage() {
  return <div>
      <Header />
      <Verification />
      <BatchResults />
      <Footer />
    </div>;
}